import React from "react";
import { Skeleton } from "@/components/ui/skeleton"; // or wherever your Skeleton is from

const SkeletonListLoader = () => {
  const skeletonRowHeight = 60; // approximate height in px of one skeleton row
  const screenHeight = typeof window !== "undefined" ? window.innerHeight : 800;
  const itemCount = Math.ceil(screenHeight / skeletonRowHeight);

  return (
    <div className="flex flex-col gap-4 px-4 py-6 overflow-hidden">
      {Array.from({ length: itemCount }).map((_, index) => (
        <div key={index} className="flex items-center gap-2">
          <Skeleton className="w-16 h-16 rounded-full" />
          <Skeleton className="h-6 w-[90%] mb-1" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonListLoader;
